import React from 'react';
import styles from '../Pages/InfoPages/infopages.module.css';
import {DiazarAlerts} from '../Components/DiazarAlerts';
import {Card, Col, Row, Space} from 'antd';
import {ResponsiveHeader} from '../Components/Layouts/ResponsiveHeader';
import {SocialMedia} from '../Components/Layouts/SocialMedia';

interface ViewProps {
    children?: React.ReactNode;
    title?: string
}

export const InfoLayout: React.FunctionComponent<ViewProps> = (props) => {

    return (
        <React.Fragment>
            { /*<DiazarBackgroundImage />*/ }
            <DiazarAlerts />
            <Row className={styles.container} justify="center">
                <Col span={24}>
                    <Space direction="vertical" className={styles.fullHeight} style={{ width: '100%' }}>
                        {/* Header */}
                        <ResponsiveHeader className={styles.marginTop} title={props.title} />

                        {/* Card principal */}
                        <Card className="shadow-sm">
                            <div className={styles.infoContainer}>{props.children}</div>
                        </Card>

                        {/* Footer Social Media */}
                        <SocialMedia />

                    </Space>
                </Col>
            </Row>

        </React.Fragment>

    );
};
